var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.326 11.624.538-3.504H7.5V5.846c0-.96.47-1.894 1.976-1.894h1.529V.97S9.618.732 8.292.732c-2.77 0-4.58 1.678-4.58 4.717v2.67H.635v3.505h3.079v8.473a12.209 12.209 0 0 0 3.788 0v-8.473h2.825Z",
    fill: "#fff"
  })));
};
export default SvgFacebook;